import { call, put, takeLatest } from 'redux-saga/effects';
import { AxiosError } from 'axios';
import { UserProfile } from '@models/User';
import { history } from '@utils/history';
import { getResponseError } from '@utils/error';
import { CamDxApi, GetCamDxRegisterParams } from '@apis/CamDxApi';
import { authAccessTokenSet } from '@components/Auth';
import { camDxVerify, camDxVerifyError } from './action';
import { SagaPayload } from '@utils/typescript';
import { AFTER_SIGN_IN_PATH, SIGNIN_PATH } from '@config';

function* handleCamDxVerify({ payload }: SagaPayload<GetCamDxRegisterParams>) {
  try {
    const { accessToken } = (yield call(CamDxApi.register, payload)) as UserProfile;
    yield put(authAccessTokenSet(accessToken));
    history.navigate(AFTER_SIGN_IN_PATH);
  } catch (e) {
    const { error } = getResponseError(e as AxiosError);
    yield put(camDxVerifyError({ errors: { camDx: error } }));
    history.navigate(SIGNIN_PATH);
  }
}

export default function* () {
  yield takeLatest(camDxVerify, handleCamDxVerify);
}
